export default Object.freeze({
    light: {
        /**
         * ‘Edit Asset’ / Viewport right-fixed side panels
         */
        left: '-5px 5px 10px 0 rgba(0, 0, 0, 0.07)',

        /**
         * floating sidenav / viewport left-fixed side panels
         */
        right: '5px 0 10px 0 rgba(0, 0, 0, 0.07)',
        /**
         * Viewport bottom-fixed button containers
         */
        top: '0 -3px 12px 0 rgba(0, 0, 0, 0.07)',
        /**
         * Dashboard panels, table grid
         */
        sm: '0 0 10px 0 rgba(0, 0, 0, 0.07)',
        /**
         * Action & system dropdown menus
         * Modal & toast content containers
         */
        md: '0 0 20px 0 rgba(0, 0, 0, 0.09)',
        /**
         * Pie chart hover
         */
        lg: '0 0 25px 0 rgba(0, 0, 0, 0.28)'
    },
    dark: {
        /**
         * ‘Edit Asset’ / Viewport right-fixed side panels
         */
        left: '-5px 5px 10px 0 rgba(0, 0, 0, 0.20)',
        /**
         * floating sidenav / viewport left-fixed - floating panels
         */
        right: '5px 0 10px 0 rgba(0, 0, 0, 0.20)',
        /**
         * Viewport bottom-fixed button containers
         */
        top: '0 -3px 12px 0 rgba(0, 0, 0, 0.40)',
        /**
         * Dashboard panels, table grid
         */
        sm: '0 0 10px 0 rgba(0, 0, 0, 0.20)',
        /**
         * Action & system dropdown menus
         * Modal & toast content containers
         */
        md: '0 0 25px 0 rgba(0, 0, 0, 0.30)',
        /**
         * Pie chart hover
         */
        lg: '0 0 20px 0 rgba(0, 0, 0, 0.60)'
    }
});
